import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getSesameCashPinToken } from 'actions/sesameCash.actions';
import moment from 'moment';

export const useCashPinToken = () => {
  const dispatch = useDispatch();
  const {
    loggedIn,
    userInfo,
    cashPinToken,
    cashPinTokenLoading,
    cashPinTokenSuccess,
    cashPinTokenExpireTime,
    cashPinTokenError,
  } = useSelector(state => ({
    loggedIn: state.app.loggedIn,
    userInfo: state.userInfo.userInfo,
    cashPinToken: state.sesameCash.cashPinToken,
    cashPinTokenLoading: state.sesameCash.cashPinTokenLoading,
    cashPinTokenSuccess: state.sesameCash.cashPinTokenSuccess,
    cashPinTokenError: state.sesameCash.cashPinTokenError,
    cashPinTokenExpireTime: state.sesameCash.cashPinTokenExpireTime,
  }));

  useEffect(() => {
    let tokenExpireTimeout = null;
    if (loggedIn && userInfo) {
      const tokenNotAvail =
        !cashPinToken && cashPinTokenSuccess !== false && !cashPinTokenError;
      const tokenExpired =
        cashPinToken && cashPinTokenExpireTime
          ? moment().isAfter(cashPinTokenExpireTime)
          : false;
      if (!cashPinTokenLoading) {
        if (tokenNotAvail || tokenExpired) {
          dispatch(getSesameCashPinToken());
        } else if (cashPinToken && cashPinTokenExpireTime) {
          const millisecondsToExpire = cashPinTokenExpireTime.diff(
            moment(),
            'milliseconds',
          );
          tokenExpireTimeout = setTimeout(() => {
            dispatch(getSesameCashPinToken());
          }, millisecondsToExpire);
        }
      }
    }
    return () => {
      clearTimeout(tokenExpireTimeout);
    };
  }, [
    dispatch,
    cashPinToken,
    cashPinTokenLoading,
    cashPinTokenError,
    cashPinTokenSuccess,
    cashPinTokenExpireTime,
    loggedIn,
    userInfo,
  ]);

  return {
    cashPinToken,
    cashPinTokenLoading,
    cashPinTokenSuccess,
    cashPinTokenError,
  };
};
